import types from '../mutation-type'
import common from '@/util/common'
export default {
  state: {
    userInfo: sessionStorage.user_info ? JSON.parse(sessionStorage.user_info) : null,
    schoolPositionList: sessionStorage.kw_school_position ? JSON.parse(sessionStorage.kw_school_position) : [],
    currentPosition: sessionStorage.kw_current_position ? JSON.parse(sessionStorage.kw_current_position) : null,
    defaultPosition: localStorage.kw_default_position ? JSON.parse(localStorage.kw_default_position) : null,
    positionVisible: false,
    poistionDialogEnableClose: true
  },
  getters: {
    // 用户机构是否是新高考模式
    userOrgNewGK: state => {
      return state.userInfo.organization.examMode === '1'
    },
    // 获取用户当前的校内角色
    userSchoolPosition: state => {
      let position = null
      // 如果当前用户有学校角色列表信息
      if (state.schoolPositionList && state.schoolPositionList.length > 0) {
        if (state.currentPosition) {
          position = state.currentPosition
        }
      }
      console.log('userSchoolPosition', position)
      return position
    },
    userMenus (state, getters) {
      if (!state.userInfo) {
        console.log('userInfo null', state, state.schoolPositionList, state.userInfo, sessionStorage.user_info)
        return []
      }
      let userMenus = new Map()
      let commonTask = {
        menuId: '9001',
        menuText: '任务进度',
        iconClassName: 'iconfont icon-shangchuan',
        url: state.userInfo.role === '1' ? '/adminTask' : '/task',
        target: 'blank',
        children: []
      }
      let token = 'Bearer ' + localStorage.getItem(`kw_token-${state.userInfo.userId}`)
      let schoolPaperCardMenu = {
        menuId: '4004',
        menuText: '题卡制作',
        iconClassName: 'el-icon-edit-outline',
        url: '',
        target: '',
        children: [
          {
            Pid: '4004',
            menuId: '40043',
            menuText: '在线题卡',
            iconClassName: 'iconfont icon-datiqia1',
            url: `/onlinecard/#/OAuth?token=` + token,
            // url: `http://127.0.0.1:8080/ssl/#/OAuth?token=` + token,
            target: 'blank',
            children: []
          }
        ]
      }
      let orgId = state.userInfo.origanization
      // 运维
      userMenus.set(common.systemRoleEnum.admin, [
      // {
      //   menuId: '1001',
      //   menuText: '首页',
      //   iconClassName: 'iconfont icon-shouye',
      //   url: '/',
      //   target: '',
      //   children: []
      // },
        {
          menuId: '1002',
          menuText: '客户',
          iconClassName: 'iconfont icon-kehu',
          url: '/customer',
          target: '',
          children: []
        }, {
          menuId: '1003',
          menuText: '监控',
          iconClassName: 'iconfont icon-xitongjiankong',
          url: '/admin/exam-list-unrelease',
          target: '',
          children: []
        }, {
          menuId: '1004',
          menuText: '基础信息',
          iconClassName: 'iconfont icon-jichuxinxi1',
          url: '',
          target: '',
          children: [
            {
              Pid: '1004',
              menuId: '10041',
              menuText: '课程科目',
              iconClassName: 'iconfont icon-xuexiao_kemu',
              url: `/admin/subject/class`,
              target: '',
              children: []
            },
            {
              Pid: '1004',
              menuId: '10042',
              menuText: '考试科目',
              iconClassName: 'iconfont icon-kaoshi',
              url: '/admin/subject/exam',
              target: '',
              children: []
            },
            {
              Pid: '1004',
              menuId: '10043',
              menuText: '行政区域',
              iconClassName: 'iconfont icon-biaoji',
              url: '',
              target: '',
              children: []
            },
            {
              Pid: '1004',
              menuId: '10044',
              menuText: '基础角色',
              iconClassName: 'iconfont icon-kehuguanli',
              url: '/admin/role/manager',
              target: '',
              children: []
            }
          ]
        }, {
          menuId: '1005',
          menuText: '代理商',
          iconClassName: 'iconfont icon-dailishang',
          url: '/admin/agent/list',
          target: '',
          children: []
        }, {
          menuId: '1006',
          menuText: '授权码',
          iconClassName: 'iconfont icon-tongjifenxi-copy',
          url: '/admin/getTempAuthorizeCode',
          target: '',
          children: []
        }, {
          menuId: '1007',
          menuText: '数据同步',
          iconClassName: 'iconfont icon-data',
          url: '/admin/sync',
          target: '',
          children: []
        }, {
          menuId: '1008',
          menuText: '操作日志',
          iconClassName: 'iconfont icon-yunweirenyuan',
          url: '/admin/behavior-record',
          target: '',
          children: []
        },
        commonTask,
        schoolPaperCardMenu])
      // 教育局信息管理员
      userMenus.set(common.systemRoleEnum.eduInfoManager, [{
        menuId: '2001',
        menuText: '考试',
        iconClassName: 'iconfont icon-kaoshi',
        url: '/',
        target: '',
        children: []
      },
      {
        menuId: '2002',
        menuText: '成绩',
        iconClassName: 'iconfont icon-chengji',
        url: `/score/list/${orgId}`,
        target: '',
        children: []
      },
      {
        menuId: '2004',
        menuText: '用户',
        iconClassName: 'iconfont icon-kehuguanli',
        url: `/org/${orgId}/member-info`,
        target: '',
        children: []
      },
      {
        menuId: '2003',
        menuText: '基础信息',
        iconClassName: 'iconfont icon-jichuxinxi1',
        url: `/org/${orgId}`,
        target: '',
        children: []
      },
      commonTask,
      schoolPaperCardMenu])
      // 教育局教研员
      userMenus.set(common.systemRoleEnum.researcher, [{
        menuId: '3001',
        menuText: '考试',
        iconClassName: 'iconfont icon-kaoshi',
        url: '/',
        target: '',
        children: []
      },
      {
        menuId: '3002',
        menuText: '成绩',
        iconClassName: 'iconfont icon-chengji',
        url: `/score/list/${orgId}`,
        target: '',
        children: []
      },
      commonTask,
      schoolPaperCardMenu])

      if (['1515633109674',
        '1483959046265',
        '1483959048499',
        '1483959049637',
        '1483959047770',
        '1576652636024',
        '1602844590651',
        '1602846142569',
        '1602843342118',
        '1602847062972'].includes(orgId) || common.getCurrentPublicMode() === 'development') {
        // schoolPaperCardMenu = {
        //   menuId: '4004',
        //   menuText: '组卷题卡',
        //   iconClassName: 'el-icon-edit-outline',
        //   url: '',
        //   target: '',
        //   children: [
        //     {
        //       Pid: '4004',
        //       menuId: '40041',
        //       menuText: '在线组卷',
        //       iconClassName: 'iconfont icon-tiqiatiku',
        //       url: `/paper/${state.userInfo.userId}/${orgId}/add/knowledge-point/0`,
        //       target: 'blank',
        //       children: []
        //     },
        //     {
        //       Pid: '4004',
        //       menuId: '40042',
        //       menuText: '我的卷库',
        //       iconClassName: 'iconfont icon-yonghu3',
        //       url: `/paper/${state.userInfo.userId}/${orgId}/list/UserPaperList`,
        //       target: '',
        //       children: []
        //     },
        //     {
        //       Pid: '4004',
        //       menuId: '40043',
        //       menuText: '在线题卡',
        //       iconClassName: 'iconfont icon-datiqia1',
        //       url: '/card/list',
        //       target: '',
        //       children: []
        //     }
        //   ]
        // }
      }
      // 学校信息管理员
      let schoolBaseInfo = [
        {
          Pid: '4003',
          menuId: '40031',
          menuText: '我校信息',
          iconClassName: 'iconfont icon-kehuguanli',
          url: `/org/${orgId}/school-info`,
          target: '',
          children: []
        },
        {
          Pid: '4003',
          menuId: '40032',
          menuText: '教师',
          iconClassName: 'iconfont icon-laoshi',
          url: '/teacher/manage',
          target: '',
          children: []
        },
        {
          Pid: '4003',
          menuId: '40033',
          menuText: '学生',
          iconClassName: 'iconfont icon-xuesheng',
          url: '/student',
          target: '',
          children: []
        },
        {
          Pid: '4003',
          menuId: '40035',
          menuText: '行政班',
          iconClassName: 'iconfont icon-xuesheng',
          url: '/class/admin',
          target: '',
          children: []
        },
        commonTask
      ]
      if (getters.userOrgNewGK) {
        schoolBaseInfo.push({
          Pid: '4003',
          menuId: '40034',
          menuText: '教学班',
          iconClassName: 'iconfont icon-xuesheng',
          url: '/class/teaching',
          target: '',
          children: []
        })
      }
      userMenus.set(common.systemRoleEnum.schoolInfoManager, [{
        menuId: '4001',
        menuText: '考试',
        iconClassName: 'iconfont icon-kaoshi',
        url: '/',
        target: '',
        children: []
      },
      {
        menuId: '4002',
        menuText: '成绩',
        iconClassName: 'iconfont icon-chengji',
        url: `/score/list/${orgId}`,
        target: '',
        children: []
      },
      {
        menuId: '4003',
        menuText: '学校信息',
        iconClassName: 'iconfont icon-jichuxinxi1',
        url: '',
        target: '',
        children: schoolBaseInfo
      },
      commonTask,
      schoolPaperCardMenu
      ])
      // 学校教师
      userMenus.set(common.systemRoleEnum.teacher, [{
        menuId: '7001',
        menuText: '考试',
        iconClassName: 'iconfont icon-kaoshi',
        url: '/',
        target: '',
        children: []
      },
      {
        menuId: '7002',
        menuText: '成绩',
        iconClassName: 'iconfont icon-chengji',
        url: `/score/list/${orgId}`,
        target: '',
        children: []
      },
      commonTask])
      // 代理商
      userMenus.set(common.systemRoleEnum.agent, [
        // {
        //   menuId: '10001',
        //   menuText: '首页',
        //   iconClassName: 'iconfont icon-shouye',
        //   url: '/',
        //   target: '',
        //   children: []
        // },
        {
          menuId: '10002',
          menuText: '客户',
          iconClassName: 'iconfont icon-kehu',
          url: '/agent-customer',
          target: '',
          children: []
        }, {
          menuId: '10003',
          menuText: '监控',
          iconClassName: 'iconfont icon-xitongjiankong',
          url: '/admin/exam-list-unrelease',
          target: '',
          children: []
        },
        commonTask])
      return userMenus.get(state.userInfo.role)
    }
  },
  actions: {
    saveUserInfo ({ commit }, data) {
      commit(types.SAVE_USER_INFO, data)
    },
    // 保存用户校内角色列表
    saveSchoolPosition ({ commit }, data) {
      commit(types.SAVE_SCHOOL_POSITION, data)
    },
    // 设置当前使用的校内角色
    setCurrentPosition ({ commit }, data) {
      commit(types.SET_CURRENT_POSITION, data)
    },
    // 初始化当前用户校内角色
    initCurrentPosition ({ commit }, data) {
      commit(types.INIT_CURRENT_POSITION, data)
    },
    // 设置用户默认校内角色
    setDefaultPosition ({ commit }, data) {
      commit(types.SET_DEFAULT_POSITION, data)
    }
  },
  mutations: {
    [types.SAVE_USER_INFO] (state, userInfo) {
      sessionStorage.setItem('user_info', JSON.stringify(userInfo))
      state.userInfo = userInfo
    },
    // 保存用户校内角色列表
    [types.SAVE_SCHOOL_POSITION] (state, schoolPositionList) {
      state.schoolPositionList = schoolPositionList
      sessionStorage.setItem('kw_school_position', JSON.stringify(schoolPositionList))
    },
    // 保存当前使用的校内角色
    [types.SET_CURRENT_POSITION] (state, position) {
      state.currentPosition = position
      sessionStorage.setItem('kw_current_position', JSON.stringify(position))
    },
    // 初始化当前用户的校内角色
    [types.INIT_CURRENT_POSITION] (state) {
      let defaultPosition = null
      let tmpPostion = null
      console.log(this)
      // 如果默认角色是当前用户的，就把默认角色设置为当前角色
      if (state.defaultPosition && state.defaultPosition.userId === state.userInfo.userId) {
        console.log('INIT_CURRENT_POSITION', state.defaultPosition, state.defaultPosition.userId, state.userInfo.userId)
        // 判断是否有默认角色设置信息
        defaultPosition = state.defaultPosition.position
        if (state.schoolPositionList && state.schoolPositionList.length > 0) {
          for (let position of state.schoolPositionList) {
            console.log(defaultPosition, position)
            if (defaultPosition.positionCode === position.positionCode &&
                defaultPosition.subjectId === position.subjectId) {
              let tmpClassObject = {
                classId: position.classId,
                grade: position.gradeLevel,
                classCode: position.classCode,
                className: position.className
              }
              if (tmpPostion === null) {
                tmpPostion = {
                  ...position,
                  positionName: common.getPostionNameByCode(position.positionCode),
                  gradeLevels: [position.gradeLevel],
                  classIds: [position.classId],
                  classes: [tmpClassObject]
                }
              } else {
                tmpPostion.gradeLevels.push(position.gradeLevel)
                tmpPostion.classIds.push(position.classId)
                tmpPostion.classes.push(tmpClassObject)
              }
            }
          }
          defaultPosition = tmpPostion
          let userId = state.defaultPosition.userId
          if (defaultPosition) {
            console.log('更新当前岗位数据', defaultPosition)
            // 更新当前岗位数据
            state.currentPosition = defaultPosition
            sessionStorage.setItem('kw_current_position', JSON.stringify(defaultPosition))
            // 更新默认岗位数据
            state.defaultPosition = {userId: userId, position: defaultPosition}
            localStorage.setItem('kw_default_position', JSON.stringify({userId: userId, position: defaultPosition}))
          } else {
            // 用户角色有变动，原有默认角色不属于该用户
            state.currentPosition = null
            sessionStorage.removeItem('kw_current_position')
            localStorage.removeItem('kw_default_position')
          }
        }
      } else { // 如果没有默认校内角色，就初始化当前校内角色
        console.log('remove_kw_current_position')
        state.currentPosition = null
        sessionStorage.removeItem('kw_current_position')
      }
    },
    // 保存用户默认校内角色
    [types.SET_DEFAULT_POSITION] (state, position) {
      state.defaultPosition = position
      localStorage.setItem('kw_default_position', JSON.stringify(position))
    },
    // 打开校内角色选择
    [types.SHOW_CHOOSE_POSITION] (state, dialogStatus) {
      console.log('SHOW_CHOOSE_POSITION', dialogStatus)
      state.positionVisible = dialogStatus.positionVisible
      state.poistionDialogEnableClose = dialogStatus.enableClose
      console.log(state.positionVisible, state.poistionDialogEnableClose)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js